export default function Backdrop() {
  return (
    <>
      <div className="grain" aria-hidden="true" />
      <div className="aurora" aria-hidden="true">
        <span />
        <span />
      </div>
    </>
  );
}
